<admin-page-simple-content [pageStatus]="$any('loaded')" [title]="'Power BI Report'" [icon]="'bar_chart'">
    <div id="powerbi-report-page" class="content">
        <section class="powerbi-report" aria-label="Power BI report">
            @if (reportUnavailable) {
                <div class="report-unavailable" role="status" aria-live="polite">
                    <p>The report isn't available.</p>
                </div>
            } @else {
                <div #reportContainer class="report-container"></div>
            }
        </section>
    </div>
</admin-page-simple-content>
